/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-props-no-spreading */
import { useElementSize, useListState } from '@mantine/hooks';
import { FC, useEffect } from 'react';
import BookitupTable from '../../../Atoms/BookitupTable';
import { WorkflowDTO } from '../../../Types/LogT';
import { WorkflowS } from '../../../Service/WorkflowS';
import EventWorkflowListItem from './EventWorkflowListItem';

const EventWorkflowList: FC<{ workflowTemplateId: string }> = ({ workflowTemplateId }) => {
  const { ref } = useElementSize();
  const [workflows, handlers] = useListState<WorkflowDTO>([]);
  const { setState: setWorkflows } = handlers;

  useEffect(() => {
    WorkflowS.fetchWorkflowsByTemplate(workflowTemplateId).then(setWorkflows);
  }, [setWorkflows, workflowTemplateId]);

  return (
    <div ref={ref}>
      <BookitupTable>
        <thead>
          <tr>
            <th>Workflow-Name im Event</th>
            <th style={{ width: 235 }}>Event</th>
            <th> </th>
          </tr>
        </thead>
        <tbody>
          {workflows.map((workflow: WorkflowDTO, idx) => (
            <EventWorkflowListItem idx={idx} workflow={workflow} key={workflow.eventId} handlers={handlers} />
          ))}
        </tbody>
      </BookitupTable>
    </div>
  );
};

export default EventWorkflowList;
